import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResponseTimeService {

  logResponseTime<T>(observable: Observable<T>, apiName: string): Observable<T> {
    const startTime = Date.now(); // Capture the start time

    return observable.pipe(
      tap({
        next: () => {
          const endTime = Date.now(); // Capture the end time
          const responseTime = endTime - startTime; // Calculate the response time
          console.log(`API response time for ${apiName}: ${responseTime} ms`);
        },
        error: () => {
          const endTime = Date.now(); // Capture the end time
          const responseTime = endTime - startTime; // Calculate the response time
          console.log(`API response time for ${apiName}: ${responseTime} ms`);
        }
      })
    );
  }
}